import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import BikeSvg from "assets/images/BikeSvg";
import GroupLifeSvg from "assets/images/GroupLife";
import { PetiSvg } from "assets/insurers/PetiSvg";
import { ToastCtx } from "components/Toast/ToastProvider";
import ErrorComponent from "components/common/ErrorComponent/ErrorComponent";
import { fetchMemberAppointments } from "modules/Appointments/api";
import { IDistributionsResp } from "modules/Appointments/types";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { useT } from "translation";
import { LSKeys, getFromLocalStorage } from "utils/ls.utils";

// TODO: Serve it via s3 URLs from API
const getInsuredLogo = (code: string) => {
  if (code === "PET-MEU") return <PetiSvg />;
  if (code === "AUTO-LIBER") return <BikeSvg />;
  if (code === "GROUPLIFE-FAIRFAX") return <GroupLifeSvg />;
  return null;
};
function AppointmentsList() {
  const isV2Auth = getFromLocalStorage(LSKeys.ACCESS_TOKEN);
  const selectedAccount = useSelector(
    (state: RootState) => state.auth.accounts?.selectedAccount
  );
  const { setToast } = useContext(ToastCtx);
  const accountId = selectedAccount?.id || "";
  const memberId = selectedAccount?.member?.id || "";
  const { t } = useT();

  const { data, isLoading, isError } = useQuery<IDistributionsResp>({
    queryFn: () => fetchMemberAppointments.queryFn({ memberId, accountId }),
    queryKey: fetchMemberAppointments.queryKey({ memberId, accountId }),
    enabled: Boolean(isV2Auth) && Boolean(accountId) && Boolean(memberId),
  });
  const distributionAccess = data?.distribution_accesses || [];

  useEffect(() => {
    if (isError) {
      setToast({
        severity: "error",
        text: t("SOMETHING_WENT_WRONG"),
      });
    }
  }, [isError, setToast, t]);

  if (isLoading)
    return (
      <Box display={"flex"} justifyContent={"center"}>
        <CircularProgress />
      </Box>
    );
  if (isError) {
    return <ErrorComponent />;
  }
  if (distributionAccess.length === 0) {
    return (
      <Box display={"flex"} justifyContent={"center"}>
        <Typography variant="h6">{t("NO_APPOINTMENT_AVAILABLE")}</Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {distributionAccess.map((distribution) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={distribution.id}>
            <Card
              sx={{
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <CardContent sx={{ padding: "24px" }}>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  gap={"8px"}
                >
                  <Box>
                    {getInsuredLogo(
                      distribution.appointment?.insurer_product
                        ?.alphabetical_code
                    )}
                  </Box>
                  <Typography fontSize={"16px"}>
                    {
                      distribution.appointment?.insurer_product
                        ?.insurance_product
                    }
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default AppointmentsList;
